import * as Actions from './actions';
import clearAuth from '@Utils/clearAuth';
import ApiService from '@Utils/apiService';
import cookie from 'react-cookies';
import { IDS_USER_ENDPOINT, IDS_ACCESS_LIST_ENDPOINT, IDS_TOKEN_COOKIE, HRIS_TOKEN_COOKIE } from '../../../../config/settings';
import { WEBHRIS_OLD_LOGIN_URL } from '../../../../config/settings';
import * as CoAPath from '../../HRAutomation/ConfigurationofApprovers/state/apiRoutes';

export const loginUser = () => async (dispatch) => {
    let loginData = {};
    dispatch(Actions.isLoading(true))
    return ApiService.get(IDS_USER_ENDPOINT)
        .then(async (response) => {
            if (response.status === 200) {
                const { data } = response;
                loginData = {
                    userFullName: data.UserFullName,
                    position: data.Position,
                    userLogEmployee: data.UsageLogEmployee,
                    companyId: parseInt(data.CompanyID, 10),
                    accountId: parseInt(data.AccountID, 10),
                    userId: parseInt(data.ID, 10),
                    userLogUserName: data.UsageLogUserName,
                    systemRole: parseInt(data.SystemRole, 10),
                    name: data.Username,
                    employeeId: data.EmployeeID,
                    moduleAccessList: data.Module,
                    accessLevelId: parseInt(data.AccessLevelID, 10),
                    isAdmin: data.IsAdmin,
                    isTimeKeeping: data.isTimeKeeping,
                    isPaytollReg: data.IsPaytollReg,
                    isApprover: "False",
                    accessList: '',
                    fcompanyId: data.FCompanyID,
                }

                await ApiService.get(CoAPath.ISAPPROVERCHECK, { userID: loginData.userId }).then((response) => {
                    if (response.data === true) {
                        loginData.isApprover = 'True';
                    }
                })

                await ApiService.get(IDS_ACCESS_LIST_ENDPOINT + '/' + loginData.accessLevelId).then((response) => {
                    loginData.accessList = response.data;
                    dispatch(Actions.setUserAuth(loginData, true, loginData.moduleAccessList, response.data));
                }).catch((error) => {
                    console.error(error);
                    return error;
                });
            }
            return loginData;
        }).catch((error) => {
            console.log(error);
            return error;
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        });
};

export const logoutUser = () => (dispatch) => {
    dispatch(Actions.setUserAuth([], false, '', '', ''));
    dispatch(Actions.refreshForm());
    clearAuth();
    cookie.remove(IDS_TOKEN_COOKIE);
    cookie.remove(HRIS_TOKEN_COOKIE);
};
